// composables/usePopularSearches.js
import { inject, provide, ref } from 'vue';

const popularSearchesSymbol = Symbol('popularSearches');

export function usePopularSearches() {
  const popularSearches = ref([]);

  const setPopularSearches = (searches) => {
    popularSearches.value = searches;
  };

  provide(popularSearchesSymbol, { popularSearches, setPopularSearches });

  return { popularSearches, setPopularSearches };
}

export function usePopularSearchesInjection() {
  const { popularSearches, setPopularSearches } = inject(popularSearchesSymbol);
  return { popularSearches, setPopularSearches };
}
